import { render, staticRenderFns } from "./PedidosList.vue?vue&type=template&id=28a105d0&scoped=true&"
import script from "./PedidosList.vue?vue&type=script&lang=ts&"
export * from "./PedidosList.vue?vue&type=script&lang=ts&"
import style0 from "./PedidosList.vue?vue&type=style&index=0&id=28a105d0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a105d0",
  null
  
)

export default component.exports